import * as i0 from '@angular/core';
import { Injectable, Pipe, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1$1 from '@angular/platform-browser';
import * as i3 from '@angular/common';
import * as i4 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';
import { FormsModule } from '@angular/forms';

class NotificationViewService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getStepNotification(data) {
        // var cstmStep = this.toEncrypt(data.isCustomStep); 
        return this.httpClient.get(`/getEmailNotifications/${data.taskId}?isCustomStep=${data.isCustomStep}&stepId=${data.stepId}`).pipe(map((response) => response));
    }
    getTaskNotification(data) {
        return this.httpClient.get(`/getEmailNotifications/${data.taskId}`).pipe(map((response) => response));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
NotificationViewService.ɵfac = function NotificationViewService_Factory(t) { return new (t || NotificationViewService)(i0.ɵɵinject(i1.HttpClient)); };
NotificationViewService.ɵprov = i0.ɵɵdefineInjectable({ token: NotificationViewService, factory: NotificationViewService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationViewService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class EscapeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
}
EscapeHtmlPipe.ɵfac = function EscapeHtmlPipe_Factory(t) { return new (t || EscapeHtmlPipe)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer)); };
EscapeHtmlPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "keepHtml", type: EscapeHtmlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EscapeHtmlPipe, [{
        type: Pipe,
        args: [{ name: 'keepHtml' }]
    }], function () { return [{ type: i1$1.DomSanitizer }]; }, null); })();

function NotificationViewComponent_div_0_div_1_th_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Status ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_9_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "check_circle");
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtemplate(5, NotificationViewComponent_div_0_div_1_td_9_mat_icon_5_Template, 2, 0, "mat-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r24 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(element_r24.emailNotfStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", element_r24.emailNotfStatus == "Sent");
} }
function NotificationViewComponent_div_0_div_1_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Email name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r26 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r26.emailName, " ");
} }
function NotificationViewComponent_div_0_div_1_th_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Subject ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r27 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r27.subject, " ");
} }
function NotificationViewComponent_div_0_div_1_th_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "From ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r28 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r28.from, " ");
} }
function NotificationViewComponent_div_0_div_1_th_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "To ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r29 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r29.to, " ");
} }
function NotificationViewComponent_div_0_div_1_th_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Triggered on ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r30 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, element_r30.triggerredOn, "MM/dd/yyyy HH:mm"), " ");
} }
function NotificationViewComponent_div_0_div_1_th_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 24);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 25);
    i0.ɵɵelementStart(1, "button", 26);
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "remove_red_eye");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_29_table_13_tr_1_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "check_circle");
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_div_1_td_29_table_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 38);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "td", 40);
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtemplate(7, NotificationViewComponent_div_0_div_1_td_29_table_13_tr_1_mat_icon_7_Template, 2, 0, "mat-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵelementStart(9, "div", 41);
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵelementStart(11, "mat-icon");
    i0.ɵɵtext(12, "subdirectory_arrow_right");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div");
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "td", 42);
    i0.ɵɵelementStart(26, "button", 43);
    i0.ɵɵlistener("click", function NotificationViewComponent_div_0_div_1_td_29_table_13_tr_1_Template_button_click_26_listener() { i0.ɵɵrestoreView(_r40); const i_r36 = ctx.index; const element_r32 = i0.ɵɵnextContext(2).$implicit; const ctx_r38 = i0.ɵɵnextContext(3); return ctx_r38.onClickCurrentItem(element_r32, i_r36); });
    i0.ɵɵelementStart(27, "mat-icon");
    i0.ɵɵtext(28, "remove_red_eye");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 44);
    i0.ɵɵelementStart(30, "div", 29);
    i0.ɵɵelementStart(31, "div", 30);
    i0.ɵɵelementStart(32, "mat-icon", 31);
    i0.ɵɵlistener("click", function NotificationViewComponent_div_0_div_1_td_29_table_13_tr_1_Template_mat_icon_click_32_listener() { i0.ɵɵrestoreView(_r40); const ctx_r41 = i0.ɵɵnextContext(5); return ctx_r41.isCurrentItem = false; });
    i0.ɵɵtext(33, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 32);
    i0.ɵɵelementStart(35, "p", 33);
    i0.ɵɵelementStart(36, "b");
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "div", 34);
    i0.ɵɵpipe(39, "keepHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r35 = ctx.$implicit;
    const i_r36 = ctx.index;
    const element_r32 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(item_r35.emailNotfStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r35.emailNotfStatus == "Sent");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1("Follow up ", item_r35.emailName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r35.subject, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r35.from, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r35.to, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(24, 10, item_r35.triggerredOn, "MM/dd/yyyy HH:mm"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("@detailExpand", ctx_r34.isCurrentItem && ctx_r34.currentItem == element_r32.uniqueId + i_r36 ? "expanded" : "collapsed");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(item_r35.templateName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(39, 13, item_r35.content), i0.ɵɵsanitizeHtml);
} }
function NotificationViewComponent_div_0_div_1_td_29_table_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 36);
    i0.ɵɵtemplate(1, NotificationViewComponent_div_0_div_1_td_29_table_13_tr_1_Template, 40, 15, "tr", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r32 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", element_r32.followUpEmailList);
} }
function NotificationViewComponent_div_0_div_1_td_29_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 27);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵelementStart(4, "mat-icon", 31);
    i0.ɵɵlistener("click", function NotificationViewComponent_div_0_div_1_td_29_Template_mat_icon_click_4_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(3); return ctx_r44.expandedElement = null; });
    i0.ɵɵtext(5, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵelementStart(7, "p", 33);
    i0.ɵɵelementStart(8, "b");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 34);
    i0.ɵɵpipe(11, "keepHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 28);
    i0.ɵɵtemplate(13, NotificationViewComponent_div_0_div_1_td_29_table_13_Template, 2, 1, "table", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r32 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("colspan", ctx_r20.columnsToDisplayWithExpand.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r32 == ctx_r20.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(element_r32.emailName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(11, 6, element_r32.content), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("@detailExpand", "expanded");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r32.followUpEmailList.length > 0);
} }
function NotificationViewComponent_div_0_div_1_tr_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 45);
} }
function NotificationViewComponent_div_0_div_1_tr_31_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 46);
    i0.ɵɵlistener("click", function NotificationViewComponent_div_0_div_1_tr_31_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r48); const element_r46 = ctx.$implicit; const ctx_r47 = i0.ɵɵnextContext(3); return ctx_r47.expandedElement = ctx_r47.expandedElement === element_r46 ? null : element_r46; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r46 = ctx.$implicit;
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("notification-expanded-row", ctx_r22.expandedElement === element_r46);
} }
function NotificationViewComponent_div_0_div_1_tr_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 47);
} }
const _c0 = function () { return ["expandedDetail"]; };
function NotificationViewComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵelementStart(2, "b");
    i0.ɵɵtext(3, "Step:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "table", 3);
    i0.ɵɵelementContainerStart(7, 4);
    i0.ɵɵtemplate(8, NotificationViewComponent_div_0_div_1_th_8_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(9, NotificationViewComponent_div_0_div_1_td_9_Template, 6, 2, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 7);
    i0.ɵɵtemplate(11, NotificationViewComponent_div_0_div_1_th_11_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(12, NotificationViewComponent_div_0_div_1_td_12_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 8);
    i0.ɵɵtemplate(14, NotificationViewComponent_div_0_div_1_th_14_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(15, NotificationViewComponent_div_0_div_1_td_15_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(16, 9);
    i0.ɵɵtemplate(17, NotificationViewComponent_div_0_div_1_th_17_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(18, NotificationViewComponent_div_0_div_1_td_18_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 10);
    i0.ɵɵtemplate(20, NotificationViewComponent_div_0_div_1_th_20_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(21, NotificationViewComponent_div_0_div_1_td_21_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(22, 11);
    i0.ɵɵtemplate(23, NotificationViewComponent_div_0_div_1_th_23_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(24, NotificationViewComponent_div_0_div_1_td_24_Template, 3, 4, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(25, 12);
    i0.ɵɵtemplate(26, NotificationViewComponent_div_0_div_1_th_26_Template, 3, 0, "th", 13);
    i0.ɵɵtemplate(27, NotificationViewComponent_div_0_div_1_td_27_Template, 4, 0, "td", 14);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(28, 15);
    i0.ɵɵtemplate(29, NotificationViewComponent_div_0_div_1_td_29_Template, 14, 8, "td", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(30, NotificationViewComponent_div_0_div_1_tr_30_Template, 1, 0, "tr", 17);
    i0.ɵɵtemplate(31, NotificationViewComponent_div_0_div_1_tr_31_Template, 1, 2, "tr", 18);
    i0.ɵɵtemplate(32, NotificationViewComponent_div_0_div_1_tr_32_Template, 1, 0, "tr", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r3.dataSource[0].stepName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r3.dataSource);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r3.columnsToDisplayWithExpand);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r3.columnsToDisplayWithExpand);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(5, _c0));
} }
function NotificationViewComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "No Data Found!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NotificationViewComponent_div_0_div_1_Template, 33, 6, "div", 0);
    i0.ɵɵtemplate(2, NotificationViewComponent_div_0_ng_template_2_Template, 3, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.dataSource.length > 0)("ngIfElse", _r4);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Status ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_9_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "check_circle");
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtemplate(5, NotificationViewComponent_ng_template_1_div_0_div_1_td_9_mat_icon_5_Template, 2, 0, "mat-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r73 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(element_r73.emailNotfStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", element_r73.emailNotfStatus == "Sent");
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Email name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r75 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r75.emailName, " ");
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Subject ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r76 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r76.subject, " ");
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "From ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r77 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r77.from, " ");
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "To ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r78 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r78.to, " ");
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Triggered on ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r79 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, element_r79.triggerredOn, "MM/dd/yyyy HH:mm"), " ");
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_th_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 24);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 25);
    i0.ɵɵelementStart(1, "button", 26);
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "remove_red_eye");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_tr_1_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "check_circle");
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 38);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "td", 40);
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtemplate(7, NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_tr_1_mat_icon_7_Template, 2, 0, "mat-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵelementStart(9, "div", 41);
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵelementStart(11, "mat-icon");
    i0.ɵɵtext(12, "subdirectory_arrow_right");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div");
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "td", 42);
    i0.ɵɵelementStart(26, "button", 43);
    i0.ɵɵlistener("click", function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_tr_1_Template_button_click_26_listener() { i0.ɵɵrestoreView(_r89); const i_r85 = ctx.index; const element_r81 = i0.ɵɵnextContext(2).$implicit; const ctx_r87 = i0.ɵɵnextContext(4); return ctx_r87.onClickCurrentItem(element_r81, i_r85); });
    i0.ɵɵelementStart(27, "mat-icon");
    i0.ɵɵtext(28, "remove_red_eye");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 44);
    i0.ɵɵelementStart(30, "div", 29);
    i0.ɵɵelementStart(31, "div", 30);
    i0.ɵɵelementStart(32, "mat-icon", 31);
    i0.ɵɵlistener("click", function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_tr_1_Template_mat_icon_click_32_listener() { i0.ɵɵrestoreView(_r89); const ctx_r90 = i0.ɵɵnextContext(6); return ctx_r90.isCurrentItem = false; });
    i0.ɵɵtext(33, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 32);
    i0.ɵɵelementStart(35, "p", 33);
    i0.ɵɵelementStart(36, "b");
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "div", 34);
    i0.ɵɵpipe(39, "keepHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r84 = ctx.$implicit;
    const i_r85 = ctx.index;
    const element_r81 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r83 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(item_r84.emailNotfStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r84.emailNotfStatus == "Sent");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1("Follow up ", item_r84.emailName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r84.subject, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r84.from, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r84.to, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(24, 10, item_r84.triggerredOn, "MM/dd/yyyy HH:mm"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("@detailExpand", ctx_r83.isCurrentItem && ctx_r83.currentItem == element_r81.uniqueId + i_r85 ? "expanded" : "collapsed");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(item_r84.templateName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(39, 13, item_r84.content), i0.ɵɵsanitizeHtml);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 36);
    i0.ɵɵtemplate(1, NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_tr_1_Template, 40, 15, "tr", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", element_r81.followUpEmailList);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 27);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵelementStart(4, "mat-icon", 31);
    i0.ɵɵlistener("click", function NotificationViewComponent_ng_template_1_div_0_div_1_td_29_Template_mat_icon_click_4_listener() { i0.ɵɵrestoreView(_r94); const ctx_r93 = i0.ɵɵnextContext(4); return ctx_r93.expandedElement = null; });
    i0.ɵɵtext(5, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵelementStart(7, "p", 33);
    i0.ɵɵelementStart(8, "b");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 34);
    i0.ɵɵpipe(11, "keepHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 28);
    i0.ɵɵtemplate(13, NotificationViewComponent_ng_template_1_div_0_div_1_td_29_table_13_Template, 2, 1, "table", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r81 = ctx.$implicit;
    const ctx_r69 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("colspan", ctx_r69.columnsToDisplayWithExpand.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r81 == ctx_r69.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(element_r81.emailName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(11, 6, element_r81.content), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("@detailExpand", "expanded");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r81.followUpEmailList.length > 0);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_tr_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 45);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_tr_31_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 46);
    i0.ɵɵlistener("click", function NotificationViewComponent_ng_template_1_div_0_div_1_tr_31_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r97); const element_r95 = ctx.$implicit; const ctx_r96 = i0.ɵɵnextContext(4); return ctx_r96.expandedElement = ctx_r96.expandedElement === element_r95 ? null : element_r95; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r95 = ctx.$implicit;
    const ctx_r71 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("notification-expanded-row", ctx_r71.expandedElement === element_r95);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_tr_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 47);
} }
function NotificationViewComponent_ng_template_1_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵelementStart(2, "b");
    i0.ɵɵtext(3, "Step:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "table", 3);
    i0.ɵɵelementContainerStart(7, 4);
    i0.ɵɵtemplate(8, NotificationViewComponent_ng_template_1_div_0_div_1_th_8_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(9, NotificationViewComponent_ng_template_1_div_0_div_1_td_9_Template, 6, 2, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 7);
    i0.ɵɵtemplate(11, NotificationViewComponent_ng_template_1_div_0_div_1_th_11_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(12, NotificationViewComponent_ng_template_1_div_0_div_1_td_12_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 8);
    i0.ɵɵtemplate(14, NotificationViewComponent_ng_template_1_div_0_div_1_th_14_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(15, NotificationViewComponent_ng_template_1_div_0_div_1_td_15_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(16, 9);
    i0.ɵɵtemplate(17, NotificationViewComponent_ng_template_1_div_0_div_1_th_17_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(18, NotificationViewComponent_ng_template_1_div_0_div_1_td_18_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 10);
    i0.ɵɵtemplate(20, NotificationViewComponent_ng_template_1_div_0_div_1_th_20_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(21, NotificationViewComponent_ng_template_1_div_0_div_1_td_21_Template, 2, 1, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(22, 11);
    i0.ɵɵtemplate(23, NotificationViewComponent_ng_template_1_div_0_div_1_th_23_Template, 3, 0, "th", 5);
    i0.ɵɵtemplate(24, NotificationViewComponent_ng_template_1_div_0_div_1_td_24_Template, 3, 4, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(25, 12);
    i0.ɵɵtemplate(26, NotificationViewComponent_ng_template_1_div_0_div_1_th_26_Template, 3, 0, "th", 13);
    i0.ɵɵtemplate(27, NotificationViewComponent_ng_template_1_div_0_div_1_td_27_Template, 4, 0, "td", 14);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(28, 15);
    i0.ɵɵtemplate(29, NotificationViewComponent_ng_template_1_div_0_div_1_td_29_Template, 14, 8, "td", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(30, NotificationViewComponent_ng_template_1_div_0_div_1_tr_30_Template, 1, 0, "tr", 17);
    i0.ɵɵtemplate(31, NotificationViewComponent_ng_template_1_div_0_div_1_tr_31_Template, 1, 2, "tr", 18);
    i0.ɵɵtemplate(32, NotificationViewComponent_ng_template_1_div_0_div_1_tr_32_Template, 1, 0, "tr", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r54 = ctx.$implicit;
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(item_r54.stepName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", item_r54.data);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r53.columnsToDisplayWithExpand);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r53.columnsToDisplayWithExpand);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(5, _c0));
} }
function NotificationViewComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NotificationViewComponent_ng_template_1_div_0_div_1_Template, 33, 6, "div", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r50.dataSource1Temp);
} }
function NotificationViewComponent_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "No Data Found!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NotificationViewComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, NotificationViewComponent_ng_template_1_div_0_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(1, NotificationViewComponent_ng_template_1_ng_template_1_Template, 3, 0, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r51 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.dataSource1Temp.length > 0)("ngIfElse", _r51);
} }
class NotificationViewComponent {
    constructor(notificationViewService, sanitizer) {
        this.notificationViewService = notificationViewService;
        this.sanitizer = sanitizer;
        this.dataSource = [];
        this.dataSource1 = [];
        this.dataSource1Temp = [];
        this.columnsToDisplay = ['emailNotfStatus', 'emailName', 'subject', 'from', 'to', 'triggerredOn'];
        this.columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
        this.isCurrentItem = false;
    }
    ngOnChanges(event) {
        if ((event.viewFrom && event.viewFrom.currentValue) && (event.inputData && event.inputData.currentValue)) {
            this.isViewFrom = event.viewFrom.currentValue;
            this.inputData = event.inputData.currentValue;
        }
    }
    ngOnInit() {
        if (this.viewFrom && this.inputData) {
            if (this.viewFrom == 'step') {
                let taskIdData;
                if (this.inputData.isCustomStep) {
                    taskIdData = sessionStorage.getItem('customStepTaskId');
                }
                else {
                    taskIdData = this.inputData.taskId;
                }
                const data = {
                    taskId: taskIdData,
                    isCustomStep: this.inputData.isCustomStep ? this.inputData.isCustomStep : false,
                    stepId: this.inputData.id
                };
                this.notificationViewService.getStepNotification(data).subscribe((response) => {
                    if (response.data) {
                        this.dataSource = response.data;
                        this.dataSource.forEach((element, i) => {
                            element.uniqueId = 'unique' + i;
                        });
                    }
                    else {
                        this.dataSource = [];
                    }
                });
            }
            else {
                const data = {
                    taskId: this.inputData.id
                };
                this.notificationViewService.getTaskNotification(data).subscribe((response) => {
                    if (response) {
                        this.dataSource1.data = response.data;
                        if (this.dataSource1.data) {
                            this.dataSource1.data.forEach((item) => {
                                if (item) {
                                    this.dataSource1Temp.push({
                                        stepName: item.stepName,
                                        data: [
                                            item
                                        ]
                                    });
                                }
                            });
                            this.dataSource1Temp.forEach((element, i) => {
                                element['data'].forEach((item, j) => {
                                    item.uniqueId = 'unique' + i + j;
                                });
                            });
                        }
                        else {
                            this.dataSource1Temp = [];
                        }
                    }
                });
            }
        }
    }
    onClickCurrentItem(element, i) {
        if (this.isCurrentItem) {
            this.isCurrentItem = false;
        }
        else {
            this.isCurrentItem = true;
        }
        this.currentItem = element.uniqueId + i;
    }
}
NotificationViewComponent.ɵfac = function NotificationViewComponent_Factory(t) { return new (t || NotificationViewComponent)(i0.ɵɵdirectiveInject(NotificationViewService), i0.ɵɵdirectiveInject(i1$1.DomSanitizer)); };
NotificationViewComponent.ɵcmp = i0.ɵɵdefineComponent({ type: NotificationViewComponent, selectors: [["lib-notification-view"]], inputs: { viewFrom: "viewFrom", inputData: "inputData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["viewFromTask", ""], ["noStepData", ""], ["mat-table", "", "multiTemplateDataRows", "", "id", "notificationTable", 1, "mat-elevation-z8", 3, "dataSource"], ["matColumnDef", "emailNotfStatus"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "customColumn", 4, "matCellDef"], ["matColumnDef", "emailName"], ["matColumnDef", "subject"], ["matColumnDef", "from"], ["matColumnDef", "to"], ["matColumnDef", "triggerredOn"], ["matColumnDef", "expand"], ["mat-header-cell", "", "aria-label", "row actions", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "align-right", 4, "matCellDef"], ["matColumnDef", "expandedDetail"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "notification-element-row", 3, "notification-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "notification-detail-row", 4, "matRowDef", "matRowDefColumns"], ["mat-header-cell", ""], ["mat-cell", "", 1, "customColumn"], [1, "statusPortion"], [4, "ngIf"], ["mat-header-cell", "", "aria-label", "row actions"], ["mat-cell", "", 1, "align-right"], ["mat-icon-button", "", "aria-label", "expand row", 1, "viewNotification"], ["mat-cell", ""], [1, "notification-element-detail"], [1, "descriptionPortion"], [1, "closeIcon"], [3, "click"], [1, "descriptionContent"], [1, "mb-0"], [1, "mb-0", 3, "innerHtml"], ["multiTemplateDataRows", "", 4, "ngIf"], ["multiTemplateDataRows", ""], ["class", "notification-element-diagram", 4, "ngFor", "ngForOf"], [1, "notification-element-diagram"], [1, "notification-sub"], [1, "customColumn", 2, "padding-left", "24px"], [1, "notification-element-sub"], [1, "align-right", 2, "padding-right", "24px"], ["mat-icon-button", "", "aria-label", "expand row", 1, "viewNotification", 3, "click"], [1, "notification-element-detail-sub"], ["mat-header-row", ""], ["mat-row", "", 1, "notification-element-row", 3, "click"], ["mat-row", "", 1, "notification-detail-row"], [1, "align-center"], ["noTaskData", ""], [4, "ngFor", "ngForOf"]], template: function NotificationViewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NotificationViewComponent_div_0_Template, 4, 2, "div", 0);
        i0.ɵɵtemplate(1, NotificationViewComponent_ng_template_1_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.isViewFrom == "step")("ngIfElse", _r1);
    } }, directives: [i3.NgIf, i4.MatTable, i4.MatColumnDef, i4.MatHeaderCellDef, i4.MatCellDef, i4.MatHeaderRowDef, i4.MatRowDef, i4.MatHeaderCell, i4.MatCell, i5.MatIcon, i3.NgForOf, i4.MatHeaderRow, i4.MatRow], pipes: [i3.DatePipe, EscapeHtmlPipe], styles: ["table[_ngcontent-%COMP%]{width:100%}tr.notification-detail-row[_ngcontent-%COMP%]{height:0}tr.notification-detail-row[_ngcontent-%COMP%]   td.mat-column-expandedDetail[_ngcontent-%COMP%]{padding:0!important}tr.notification-detail-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border:none!important}tr.notification-element-row[_ngcontent-%COMP%]:not(.notification-expanded-row):hover{background:#f5f5f5}tr.notification-element-row[_ngcontent-%COMP%]:not(.notification-expanded-row):active{background:#efefef}.notification-element-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-bottom-width:0;word-break:break-all;width:16.66%;border:none!important;text-align:left}.notification-element-detail[_ngcontent-%COMP%], .notification-element-detail-sub[_ngcontent-%COMP%]{overflow:hidden;background-color:#fff!important}.notification-element-detail-sub[_ngcontent-%COMP%]{margin:0 3px 15px!important}.notification-element-diagram[_ngcontent-%COMP%]{padding:8px;margin:8px 0}.notification-sub[_ngcontent-%COMP%]:hover{background-color:#f6f6f6}.notification-element-description[_ngcontent-%COMP%]{padding:16px}.notification-element-description-attribution[_ngcontent-%COMP%]{opacity:.5}h6[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{text-transform:capitalize;font-weight:600}.notification-sub[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{word-break:break-all;width:16.66%;text-align:left}.notification-element-sub[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.descriptionPortion[_ngcontent-%COMP%]{position:relative;background:#f0f0f0;padding:15px;border:1px solid #ddd;margin:10px}.descriptionPortion[_ngcontent-%COMP%]   .closeIcon[_ngcontent-%COMP%]{text-align:right;line-height:.5;color:#bdb5b5}.descriptionPortion[_ngcontent-%COMP%]   .closeIcon[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:18px;width:18px;font-size:18px}.descriptionPortion[_ngcontent-%COMP%]   .descriptionContent[_ngcontent-%COMP%]{max-height:150px;overflow-y:auto}.descriptionPortion[_ngcontent-%COMP%]:after, .descriptionPortion[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;right:4px;border:11px solid transparent;border-bottom-color:#ddd}.descriptionPortion[_ngcontent-%COMP%]:after{right:5px;border:10px solid transparent;border-bottom-color:#f0f0f0}.align-right[_ngcontent-%COMP%]{text-align:right!important}.statusPortion[_ngcontent-%COMP%]{display:flex}.statusPortion[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#35ba35;height:16px;width:16px;font-size:16px;display:flex;padding-left:6px;padding-top:3px}.viewNotification[_ngcontent-%COMP%]{border:none;background-color:transparent}h6[_ngcontent-%COMP%]{background-color:#80def3;padding:10px;border-top-right-radius:20px;border-bottom-right-radius:20px;margin:14px 0}.align-center[_ngcontent-%COMP%]{text-align:center}"], data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationViewComponent, [{
        type: Component,
        args: [{
                selector: 'lib-notification-view',
                templateUrl: './notification-view.component.html',
                styleUrls: ['./notification-view.component.scss'],
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ]
            }]
    }], function () { return [{ type: NotificationViewService }, { type: i1$1.DomSanitizer }]; }, { viewFrom: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class NotificationViewModule {
}
NotificationViewModule.ɵfac = function NotificationViewModule_Factory(t) { return new (t || NotificationViewModule)(); };
NotificationViewModule.ɵmod = i0.ɵɵdefineNgModule({ type: NotificationViewModule });
NotificationViewModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            MatTableModule,
            MatIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NotificationViewModule, { declarations: [NotificationViewComponent, EscapeHtmlPipe], imports: [PrimengLibraryModule,
        FormsModule,
        MatTableModule,
        MatIconModule], exports: [NotificationViewComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationViewModule, [{
        type: NgModule,
        args: [{
                declarations: [NotificationViewComponent, EscapeHtmlPipe],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    MatTableModule,
                    MatIconModule
                ],
                exports: [NotificationViewComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of notification-view
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NotificationViewComponent, NotificationViewModule, NotificationViewService };
//# sourceMappingURL=notification-view.js.map
